
define('include/requirejs-text/text!modules/Shelf/views/Shelf_Item_View.html',[],function () { return '<script type="text/x-underscore" id=\'shelf-item-template\'>\n    <span   id="status"   class="fa fa-circle fa-5x"/>\n    <video  id="video"    class="hidden" autoplay/>\n    <img    id="picture"  class="picture" src=\'images/item.webp\' alt="Channel Image"/>\n    <span   id="username" class="username"/>\n</script>\n';});

define('include/require-css/css!modules/Shelf/views/Shelf_Item_View',[],function(){});
/*
 * @Copyright (C) 2016-01-03 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */
 
define('modules/Shelf/views/Shelf_Item_View',[
    'jquery',
    'underscore',
    'backbone',
    'modules/App/models/Attachment_Record_Model',
    'include/requirejs-text/text!./Shelf_Item_View.html',
    'include/require-css/css!./Shelf_Item_View.css',
], function(
        $,
        _,
        Backbone,
        Attachment_Record_Model,
        Template
    ) {

    /**
     * @class Shelf_Item_View
     * Backbone.View
     *
     * Carga una ventana para con un peers en el shelf
     */
    var Shelf_Item_View = Backbone.View.extend({
        TAG : 'Shelf_Item_View',
        id: null,   
        model: null,
        template: null,
        template: null,
        appmodel: null,
        publicity: null,
        playvideo: false,

        /**
         * Propiedades para la vista
         */
        className: 'shelf_item_view',
        
        /**
         * Shelf_Item_View::_template_
         * Optiones para graficar la template
         */
        _template_: {
            html    : Template,
            name    : '#shelf-item-template'
        },
        
        /**
         * Shelf_Item_View::events
         * Objeto de los eventos para ItemShelf
         */
        events: {
            'click'         : 'select',
        },
        
        /**
         * Shelf_Item_View.initialize
         * Constructor de la ventana de ItemShelf 
         * @param <Object> attributes - Atributos de la vista
         * @param <App_Record_Model> appmodel - Modelo de la aplicacion
         */
        initialize: function(atributes, appmodel) {
            var self = this;
            void 0;
            self.appmodel = appmodel;
            self.template = self.appmodel.getTemplate(self._template_);
            void 0;
        },
        
        /**
         * Shelf_Item_View.render
         * Renderiza la vista
         */
        render: function(parent) {
            var self = this;
            void 0;
            self.$el.html(self.template(self));
            parent.append(self.$el);
            self.$('#video').on('playing', function(event) {
                self.$('#video').removeClass('hidden');
            });
            // @note - solo la primera vez que el video es cargado
            self.$('#video').one('loadeddata', function(event) {
                self.$('#video').get(0).play();
            });
            void 0;
        },
        
        /**
         * Shelf_Item_View.set
         * @brief Envia un peer a la vista
         */
        set: function(peer) {
            var self = this;
            void 0;
            if(!_.isNull(self.model)) {
                var status = self.model.get('status');
                self.$('#status').removeClass(status);
            }
            self.model = peer;
            self.publicity = null;
            self.id = self.model.id;
            if(self.model.id>0) {
                var params = {name: 'image', res_id: self.model.id, res_model: 'res.partner'};
                self.model.attachments.getModel(params, function(error, attachment) {
                    if(error) return;
                    self.$('.picture').attr('src', attachment.path());
                });
                self.$('#status').addClass(self.model.get('status'));
            } else {
                self.$('.picture').attr('src', 'images/item.webp');
            }
            self.$('#username').text(self.model.get('name'));
            void 0;
        },
        
        /**
         * Shelf_Item_View.select
         * Accion de selecion de un itemShelf
         */
        select: function(event) {
            var self = this;
            void 0;
            logEvent(self.TAG+'_select');
            var supplier = self.appmodel.peers.getSupplier();
            if(_.isUndefined(supplier)) {
                self.appmodel.getModule('Auth', function(auth) {
                    auth.show();
                });
            } else if(self.model.id>0) {
                self.appmodel.peers.getModel({id: self.model.id}, function(error, peer) {
                    if(peer.get('message')!=='') supplier.messages.add({from: peer.id, username: peer.get('name'), message: peer.get('message')});
                    self.appmodel.getModule({module: 'Room', model: peer, parent: $('#app_wrapper')}, function(room) {
                        room.show();
                    });
                });
            }
            void 0;
        }
        
    });
    
    return Shelf_Item_View;

});

define('include/requirejs-text/text!modules/Shelf/views/Shelf_Index_View.html',[],function () { return '<script type="text/x-underscore" id=\'shelf-index-template\'>\n    <div class="shelf_index_body">\n        <!-- Shelf_Item_View -->\n    </div>\n    <div class="shelf_index_footer">\n        <div id="shelf_index_navigator"/>\n    </div>\n</script>\n';});

/*
  backgrid-paginator
  http://github.com/wyuenho/backgrid

  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors
  Licensed under the MIT @license.
*/
!function(a,b){"object"==typeof exports?module.exports=b(require("underscore"),require("backbone"),require("backgrid"),require("backbone-pageable")):b(a._,a.Backbone,a.Backgrid)}(this,function(a,b,c){var d=c.Extension.PageHandle=b.View.extend({tagName:"li",events:{"click a":"changePage"},title:a.template("Page <%- label %>",null,{variable:null}),isRewind:!1,isBack:!1,isForward:!1,isFastForward:!1,initialize:function(b){var c=this.collection,d=c.state,e=d.currentPage,f=d.firstPage,g=d.lastPage;a.extend(this,a.pick(b,["isRewind","isBack","isForward","isFastForward"]));var h;this.isRewind?h=f:this.isBack?h=Math.max(f,e-1):this.isForward?h=Math.min(g,e+1):this.isFastForward?h=g:(h=+b.pageIndex,h=f?h+1:h),this.pageIndex=h,this.label=(b.label||(f?h:h+1))+"";var i=b.title||this.title;this.title=a.isFunction(i)?i({label:this.label}):i},render:function(){this.$el.empty();var a=document.createElement("a");a.href="#",this.title&&(a.title=this.title),a.innerHTML=this.label,this.el.appendChild(a);var b=this.collection,c=b.state,d=c.currentPage,e=this.pageIndex;return this.isRewind&&d==c.firstPage||this.isBack&&!b.hasPrevious()||this.isForward&&!b.hasNext()||this.isFastForward&&(d==c.lastPage||c.totalPages<1)?this.$el.addClass("disabled"):this.isRewind||this.isBack||this.isForward||this.isFastForward||c.currentPage!=e||this.$el.addClass("active"),this.delegateEvents(),this},changePage:function(a){a.preventDefault();var b=this.$el,c=this.collection;return b.hasClass("active")||b.hasClass("disabled")||(this.isRewind?c.getFirstPage():this.isBack?c.getPreviousPage():this.isForward?c.getNextPage():this.isFastForward?c.getLastPage():c.getPage(this.pageIndex,{reset:!0})),this}}),e=c.Extension.Paginator=b.View.extend({className:"backgrid-paginator",windowSize:10,slideScale:.5,controls:{rewind:{label:"《",title:"First"},back:{label:"〈",title:"Previous"},forward:{label:"〉",title:"Next"},fastForward:{label:"》",title:"Last"}},renderIndexedPageHandles:!0,pageHandle:d,goBackFirstOnSort:!0,initialize:function(b){var c=this;c.controls=a.defaults(b.controls||{},c.controls,e.prototype.controls),a.extend(c,a.pick(b||{},"windowSize","pageHandle","slideScale","goBackFirstOnSort","renderIndexedPageHandles"));var d=c.collection;c.listenTo(d,"add",c.render),c.listenTo(d,"remove",c.render),c.listenTo(d,"reset",c.render),c.listenTo(d,"backgrid:sorted",function(){c.goBackFirstOnSort&&d.getFirstPage({reset:!0})})},slideMaybe:function(a,b,c,d){return Math.round(c%d/d)},slideThisMuch:function(a,b,c,d,e){return~~(d*e)},_calculateWindow:function(){var a=this.collection,b=a.state,c=b.firstPage,d=+b.lastPage;d=Math.max(0,c?d-1:d);var e=Math.max(b.currentPage,b.firstPage);e=c?e-1:e;var f=this.windowSize,g=this.slideScale,h=Math.floor(e/f)*f;e<=d-this.slideThisMuch()&&(h+=this.slideMaybe(c,d,e,f,g)*this.slideThisMuch(c,d,e,f,g));var i=Math.min(d+1,h+f);return[h,i]},makeHandles:function(){var b=[],c=this.collection,d=this._calculateWindow(),e=d[0],f=d[1];if(this.renderIndexedPageHandles)for(var g=e;f>g;g++)b.push(new this.pageHandle({collection:c,pageIndex:g}));var h=this.controls;return a.each(["back","rewind","forward","fastForward"],function(a){var d=h[a];if(d){var e={collection:c,title:d.title,label:d.label};e["is"+a.slice(0,1).toUpperCase()+a.slice(1)]=!0;var f=new this.pageHandle(e);"rewind"==a||"back"==a?b.unshift(f):b.push(f)}},this),b},render:function(){if(this.$el.empty(),this.handles)for(var a=0,b=this.handles.length;b>a;a++)this.handles[a].remove();for(var c=this.handles=this.makeHandles(),d=document.createElement("ul"),a=0;a<c.length;a++)d.appendChild(c[a].render().el);return this.el.appendChild(d),this}})});
define("backgridPaginator", function(){});

define('include/require-css/css!include/backgrid-paginator/backgrid-paginator.min',[],function(){});
define('include/require-css/css!include/backgrid/lib/backgrid',[],function(){});
define('include/require-css/css!modules/Shelf/views/Shelf_Index_View',[],function(){});
/*
 * @Copyright (C) 2016-01-03 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */

define('modules/Shelf/views/Shelf_Index_View',[
    'jquery',
    'underscore',
    'backbone',
    './Shelf_Item_View',
    'include/requirejs-text/text!./Shelf_Index_View.html',
    'backgridPaginator',
    'include/require-css/css!include/backgrid-paginator/backgrid-paginator.min.css',
    'include/require-css/css!include/backgrid/lib/backgrid.css',
    'include/require-css/css!./Shelf_Index_View.css'
], function($, _, Backbone, Shelf_Item_View, Template) {
    
    /**
     * @class Shelf_Index_View
     *
     * Backbone.View
     * Carga la ventana de shelf para las busquedas
     */
    var Shelf_Index_View = Backbone.View.extend({
        TAG: 'Shelf_Index_View',
        items: [],
        template: null,
        searchmodel: null,
        
        /**
         * Shelf_Index_View::wrapper
         * Optiones para graficar la vista
         */
        wrapper: {
            id: 'shelf',
            style: null,
            html: Template,
            class: 'shelf_wrapper',
            parent: '.main_content',
            extraClass: 'tab-pane active'
        },
        
        /**
         * Shelf_Index_View::events
         * Objeto de los eventos para la vista
         */
        events: {
            
        },

        /**
         * Shelf_Index_View.initialize
         * Constructor de la vista de shelf 
         * @param <Object> attributes - Atributos de la vista
         * @param <App_Record_Model> appmodel - Modelo de la aplicacion
         */
        
        initialize: function(attributes, appmodel) {
            var self = this;
            void 0;
            self.appmodel = appmodel;
            var wrapper = self.appmodel.getWrapper(self.wrapper);
            self.setElement(wrapper);
            var template = self.$("#shelf-index-template").html();
            self.template = _.template(template);
            void 0;
        },
        
        /**
         * Shelf_Index_View.render
         * Renderiza el modulo
         */
        render: function() {
            var self = this;
            void 0;
            self.$el.html(self.template(self));
            for(i=0; i<self.appmodel.get('max_shelf_items'); i++) {
                var item = new Shelf_Item_View(null, self.appmodel);
                item.render(self.$('.shelf_index_body'));
                self.items.push(item);
            }
            self.search = self.appmodel.modules.search;
            // @note - Primero debe cargar el modulo de search
            var paginator = new Backgrid.Extension.Paginator({
                windowSize: 7,
                collection: self.search.peers
            });
            self.$('#shelf_index_navigator').html(paginator.render().el);
            self.search.peers.on('add', self.onAdd, self);
            self.search.peers.getFirstPage({
                appmodel: self.appmodel,
                success: function(collection, response, options) {
                    self.find();
                }
            });
            _.delay(function() {
                self.search.peers.on('sync', self.onSync, self);
            }, 500);
            void 0;
        },
        
        /**
         * Shelf_Index_View.onSync
         * Es llamado cuando se navega por los resultados
         */
        onSync: function() {
            var self = this;
            void 0;
            _.each(self.items, function(item, index, list) {
                var peer = self.search.peers.pick(index);
                if(!_.isUndefined(peer)) item.set(peer);
            });
            void 0;
        },
        
        /**
         * Shelf_Index_View.onAdd
         * Es llamado cuando se pide una nueva pagina
         */
        onAdd: function(peer) {
            var self = this;
            void 0;
            // @note - peers no es acumulativo en server mode
            var index = self.search.peers.indexOf(peer);
            var item = self.items[index];
            if(!_.isUndefined(item)) item.model = peer;
            void 0;
        },

        /**
         * Shelf_Index_View.find
         * Encuentra un item en modo stream y lo carga
         * @private
         */
        find: function() {
            var self = this;
            void 0;
            var model = undefined;
            var res_id = self.appmodel.get('res_id');
            if(_.isNull(res_id)) {
                var peer = self.appmodel.peers.getSupplier();
                if(!_.isUndefined(peer)) res_id = peer.get('res_id');
            }
            if(!_.isNull(res_id)) {
                var _model_ = self.search.peers.constructor.getRawModel({id: res_id}, {appmodel: self.appmodel});
                model = self.search.peers.add(_model_, {at: 1});
            } else {
                model = self.search.peers.findWhere({status: 'stream'});
            }
            var index = self.search.peers.indexOf(model);
            self.items[index].select();
            void 0;
        }
        
    });
    
    return Shelf_Index_View;
    
});

/*
 * @Copyright (C) 2016-01-03 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */

define('modules/Shelf/__init__',[
    'jquery',
    'underscore',
    'backbone',
    './views/Shelf_Index_View'
], function($, _, Backbone, Shelf_Index_View) {
    
    return Shelf_Index_View;
    
});

(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.shelf_item_view {\n    width: 293px;\n    height: 194px;\n    padding: 0px;\n    color: #cccccc;\n    overflow: hidden;\n    position: relative;\n    border-radius: 4px;\n    display: inline-block;\n    margin: -1px 1px -1px 1px;\n    background-color: #0000003b;\n}\n\n/*\n.shelf_item_view:hover {\n    z-index: 2 !important;\n    transform: scale(1.02, 1.02) !important;\n    transition: all 0.3s ease 0s;\n}\n*/\n\n.shelf_item_view > video {\n    height: 100%;\n    width: 100%;\n}\n\n.shelf_item_view #picture {\n    opacity: 1;\n}\n\n.shelf_item_view #picture:hover {\n    position: relative;\n    z-index: 2 !important;\n}\n\n.shelf_item_view .blinker {\n    animation: blinker 2s cubic-bezier(.5, 0, 1, 1) infinite alternate;  \n}\n\n@keyframes blinker {\n    to {\n        opacity: 0.2;\n    } \n}\n\n.shelf_item_view > span {\n    z-index: 3;\n    position: absolute;   \n}\n\n.shelf_item_view #status {\n    font-size: 18px;\n    right: 10px;\n    top: 7px;\n}\n\n.shelf_item_view #username {\n    width: 95%;\n    height: 25px;\n    left: 0px;\n    bottom: 0px;\n    z-index: 2;\n    color: #000;\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n    font-family: Arial,sans-serif;\n    background-color: rgba(255, 255, 255, 0.9);\n    margin: 5px 7px;\n    border-radius: 7px;\n}\n\n.shelf_item_view #play, .shelf_item_view #load{\n    top: 33%;\n    left: 0;\n    right: 0;\n    opacity: 0.9;\n}\n\n.shelf_item_view #picture {\n    /*opacity: 0.7;*/\n    height: 100%;\n    width: 100%;\n}\n\n/* Phone Style*/\n@media only screen and (hover: none) and (pointer: coarse) {\n\n    .shelf_item_view {\n        width: 49%;\n    }\n\n}\n/* Phone Style: end*/\n.backgrid-paginator{text-align:center;border-top:0;-webkit-border-radius:0 0 4px 4px;-moz-border-radius:0 0 4px 4px;border-radius:0 0 4px 4px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.backgrid-paginator ul{display:inline-block;*display:inline;margin:5px 0;*zoom:1}.backgrid-paginator ul>li{display:inline}.backgrid-paginator ul>li>a,.backgrid-paginator ul>li>span{float:left;width:30px;height:30px;padding:0;line-height:30px;text-decoration:none}.backgrid-paginator ul>li>a:hover,.backgrid-paginator ul>.active>a,.backgrid-paginator ul>.active>span{background-color:#f5f5f5}.backgrid-paginator ul>.active>a,.backgrid-paginator ul>.active>span{color:#999;cursor:default}.backgrid-paginator ul>.disabled>span,.backgrid-paginator ul>.disabled>a,.backgrid-paginator ul>.disabled>a:hover{color:#999;cursor:default}/*\n  backgrid\n  http://github.com/wyuenho/backgrid\n\n  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors\n  Licensed under the MIT license.\n*/\n\n.backgrid-container {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 465px;\n  padding: 0;\n  overflow: auto;\n  border: 0;\n}\n\n.backgrid {\n  width: 100%;\n  max-width: 100%;\n  background-color: transparent;\n  border-collapse: collapse;\n  -webkit-border-radius: 4px;\n     -moz-border-radius: 4px;\n          border-radius: 4px;\n}\n\n.backgrid th,\n.backgrid td {\n  display: none;\n  height: 20px;\n  max-width: 250px;\n  padding: 4px 5px;\n  overflow: hidden;\n  line-height: 20px;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n  border-bottom: 1px solid #DDD;\n}\n\n.backgrid th.renderable,\n.backgrid td.renderable {\n  display: table-cell;\n}\n\n.backgrid th {\n  font-weight: bold;\n  text-align: center;\n}\n\n.backgrid th.sortable a {\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.backgrid thead th {\n  vertical-align: bottom;\n  background-color: #f9f9f9;\n}\n\n.backgrid thead th a {\n  display: block;\n}\n\n.backgrid.backgrid-striped tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.backgrid tbody tr.empty {\n  font-style: italic;\n  color: gray;\n}\n\n.backgrid tbody tr.empty td {\n  display: table-cell;\n  text-align: center;\n}\n\n.backgrid td.editor {\n  padding: 0;\n}\n\n.backgrid td.editor,\n.backgrid tbody tr:nth-child(odd) td.editor {\n  background-color: rgba(82, 168, 236, 0.1);\n  outline: 1px solid rgba(82, 168, 236, 0.8);\n  outline-offset: -1px;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-transition-duration: 200ms;\n     -moz-transition-duration: 200ms;\n       -o-transition-duration: 200ms;\n          transition-duration: 200ms;\n  -webkit-transition-property: width, outline, background-color;\n     -moz-transition-property: width, outline, background-color;\n       -o-transition-property: width, outline, background-color;\n          transition-property: width, outline, background-color;\n  -webkit-transition-timing-function: ease-in-out;\n     -moz-transition-timing-function: ease-in-out;\n       -o-transition-timing-function: ease-in-out;\n          transition-timing-function: ease-in-out;\n}\n\n.backgrid td.editor input[type=text] {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0 5px;\n  margin: 0;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  -webkit-box-shadow: none;\n     -moz-box-shadow: none;\n          box-shadow: none;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n}\n\n.backgrid td.editor input[type=text]::-ms-clear {\n  display: none;\n}\n\n.backgrid td.error,\n.backgrid tbody tr:nth-child(odd) td.error {\n  background-color: rgba(255, 210, 77, 0.1);\n  outline: 1px solid #ffd24d;\n}\n\n.backgrid td.editor :focus,\n.backgrid th.editor :focus {\n  outline: 0;\n}\n\n.backgrid .sort-caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.3em;\n  border: 0;\n  content: \"\";\n}\n\n.backgrid .ascending .sort-caret {\n  vertical-align: baseline;\n  border-top: none;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid #000000;\n  border-left: 4px solid transparent;\n}\n\n.backgrid .descending .sort-caret {\n  vertical-align: super;\n  border-top: 4px solid #000000;\n  border-right: 4px solid transparent;\n  border-bottom: none;\n  border-left: 4px solid transparent;\n}\n\n.backgrid .string-cell,\n.backgrid .uri-cell,\n.backgrid .email-cell,\n.backgrid .string-cell.editor input[type=text],\n.backgrid .uri-cell.editor input[type=text],\n.backgrid .email-cell.editor input[type=text] {\n  text-align: left;\n}\n\n.backgrid .date-cell,\n.backgrid .time-cell,\n.backgrid .datetime-cell,\n.backgrid .number-cell,\n.backgrid .integer-cell,\n.backgrid .percent-cell,\n.backgrid .date-cell.editor input[type=text],\n.backgrid .time-cell.editor input[type=text],\n.backgrid .datetime-cell.editor input[type=text],\n.backgrid .number-cell.editor input[type=text],\n.backgrid .integer-cell.editor input[type=text],\n.backgrid .percent-cell.editor input[type=text] {\n  text-align: right;\n}\n\n.backgrid .boolean-cell,\n.backgrid .boolean-cell.editor input[type=checkbox] {\n  text-align: center;\n}\n\n.backgrid .select-cell {\n  text-align: center;\n}\n\n.backgrid .select-cell.editor {\n  padding: 0;\n}\n\n.backgrid .select-cell.editor select {\n  display: block;\n  width: 100%;\n  height: 28px;\n  padding: 4px 5px;\n  margin: 0;\n  line-height: 28px;\n  vertical-align: middle;\n  background-color: white;\n  border: 0;\n  outline: 0;\n  -webkit-box-shadow: none;\n     -moz-box-shadow: none;\n          box-shadow: none;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.backgrid .select-cell.editor select[multiple] {\n  height: auto;\n}\n\n.backgrid .select-cell.editor :focus {\n  border: 0;\n  outline: 0;\n}\n\n.backgrid .select-cell.editor select::-moz-focus-inner,\n.backgrid .select-cell.editor optgroup::-moz-focus-inner,\n.backgrid .select-cell.editor option::-moz-focus-inner,\n.backgrid .select-cell.editor select::-o-focus-inner,\n.backgrid .select-cell.editor optgroup::-o-focus-inner,\n.backgrid .select-cell.editor option::-o-focus-inner {\n  border: 0;\n}.shelf_wrapper {\n    padding: 5px 0px 0px 0px;\n}\n\n.shelf_wrapper .shelf_index_footer {\n    height: 40px;\n    background-image: linear-gradient(to bottom, #365c89 20%, #477ab5 100%);\n}\n\n.shelf_index_footer #shelf_index_navigator {\n    height: 100%;\n    margin: 0px auto;\n}\n\n.shelf_index_footer #shelf_index_navigator td {\n    color: #ccc;\n    width: 20px;\n    cursor:pointer;\n}\n\n.shelf_index_footer #shelf_index_navigator .select {\n    color: #000;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n/* Phone Style:*/\n\n@media only screen and (hover: none) and (pointer: coarse) {\n\n    .shelf_wrapper .shelf_index_footer {\n        border-radius: 0 0 5px 5px;\n    }\n\n}\n\n/* Phone Style: end */\n');
